import { useNavigate } from 'react-router-dom';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';

import Accepted from 'hb-react/frontoffice/apps/Mentoring/components/SharedCard/Buttons/Accepted';
import Available from 'hb-react/frontoffice/apps/Mentoring/components/SharedCard/Buttons/Available';
import {
  type MentorProfileIndexCard,
  type Program,
} from 'hb-react/frontoffice/apps/Mentoring/types';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';

interface MentorButtonsProps {
  disabledAccess?: boolean;
  mentorProfile: MentorProfileIndexCard;
  program: Program;
}

const MentorButtons = ({
  mentorProfile,
  program,
  disabledAccess,
}: MentorButtonsProps) => {
  const { mentor_label: mentorLabel, mentee_label: menteeLabel } = program;
  const {
    id,
    user_id: userId,
    has_reached_mentees_limit: hasReachedMenteesLimit,
    relationship_with_current_user: relationshipWithCurrentUser,
  } = mentorProfile;
  const { currentUser } = useDefaultAppContexts();

  const navigate = useNavigate();

  if (relationshipWithCurrentUser?.status === 'accepted') {
    return (
      <Accepted
        relationshipWithCurrentUser={relationshipWithCurrentUser}
        userId={userId}
        program={program}
      />
    );
  }

  const statusWithConnexion =
    !relationshipWithCurrentUser ||
    relationshipWithCurrentUser.status === 'rejected' ||
    relationshipWithCurrentUser.status === 'terminated';

  if (statusWithConnexion && currentUser?.can_be_a_mentee) {
    return (
      <Available
        hasReachedMenteesLimit={hasReachedMenteesLimit}
        mentorLabel={mentorLabel}
        menteeLabel={menteeLabel}
        onClickSubmitApplication={() => navigate(`../apply/${id}/mentee`)}
        disabledAccess={disabledAccess}
      />
    );
  }

  if (relationshipWithCurrentUser?.status === 'pending') {
    return (
      <Box pt={4} mt={2} font="footnote-asphalt-italic">
        <Button isDisabled>{s__('Mentoring|Pending application')}</Button>
      </Box>
    );
  }

  return null;
};

export default MentorButtons;
